// @flow
import { combineActions, handleActions } from 'redux-actions';
import { upsertResource, upsertResources, upsertResourceSetupUndo, upsertResourcesSetupUndo, completeWithError, resetResources } from 'data/qcsSyncResourceReducerHelpers';
import { mkQcsSyncResourceStore } from 'data/qcsSyncResourceTypes';
import { DateTime } from 'luxon';

import * as actions from './actions';

const reducer = handleActions({

  [actions.createTag]:
    (state, { payload: tag }) => upsertResource(state, tag),
  [actions.createTagSuccess]:
    (state, action) => {
      const updatedAction = !action.payload.createdAt ? {...action, payload: action.payload.set('createdAt', DateTime.utc().toISO())} : action;
      return upsertResourceSetupUndo(state, updatedAction, actions.deleteTag);
    },
  [actions.updateTag]:
    (state, action) => upsertResourceSetupUndo(state, action, actions.updateTag),
  [actions.updateTagSuccess]:
    (state, { payload: tag }) => upsertResource(state, tag),

  [actions.deleteTag]:
    (state, action) => upsertResourceSetupUndo(state, action, actions.createTag),
  [actions.deleteTagSuccess]:
    (state, { payload: tag }) => upsertResource(state, tag),

  [actions.batchTags]:
    (state, action) => upsertResourcesSetupUndo(state, action, actions.batchTags, false),
  [actions.batchTagsSuccess]:
    (state, action) => upsertResourcesSetupUndo(state, action, actions.batchTags, true),

  [actions.getTags]:
    (state) => state.set( 'isLoading', true),
  [actions.getTagsSuccess]:
    (state, { payload: data }) => upsertResources(state, data),
  [actions.getTagsFailure]:
    (state, { payload: error }) => completeWithError(state, error),

  [combineActions(
    actions.createTagFailure,
    actions.updateTagFailure,
    actions.deleteTagFailure,
    actions.batchTagsFailure,
  )]: (state, {payload: error, asyncDispatch}) => {
    asyncDispatch(actions.getTags());
    return resetResources(state, error);
  },

}, mkQcsSyncResourceStore());

export const REDUCER_KEY = 'tagStore';
export default reducer;
